import { contentApi } from '@/store/services/contentApi';
import { AppDispatch, store } from '../store';
import { PostFeedItem } from '@/features/posts/types';

const getMyInvalidatedPostsEntries = (visibility: PostFeedItem['visibility']) => {
  const entries = contentApi.util.selectInvalidatedBy(
    store.getState(),
    visibility === 'unknown'
      ? ['PrivatePosts', 'PublicPosts']
      : [visibility === 'private' ? 'PrivatePosts' : 'PublicPosts']
  );

  return entries;
};

export const removeMyPostFromCached = ({
  dispatch,
  postId,
  visibility,
}: {
  dispatch: AppDispatch;
  postId: PostFeedItem['id'];
  visibility: PostFeedItem['visibility'];
}) => {
  const entries = getMyInvalidatedPostsEntries(visibility);
  const actions = entries.map(({ originalArgs }) =>
    dispatch(
      contentApi.util.updateQueryData(
        visibility === 'public' ? 'getMyProfilePublicPosts' : 'getMyProfilePrivatePosts',
        originalArgs,
        (cachedData) => {
          const postPage = cachedData.pages.find((page) =>
            page.data.find(({ id }) => id === postId)
          );
          if (!postPage) return cachedData;
          return {
            ...cachedData,
            pages: cachedData.pages.map((page) =>
              page.continuationToken === postPage.continuationToken
                ? { ...page, data: page.data.filter(({ id }) => id !== postId) }
                : page
            ),
          };
        }
      )
    )
  );
  return actions;
};
